<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>Suppliers</h2>
  <button *appHasAnyPrivilege="'SUPPLIER_CREATE'" nz-button nzType="primary" (click)="navigateAddNew()">
    Add New Supplier
  </button>
</div>

<section id="inventory-records">

  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="loading ? 'hidden' : 'block'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col lg:flex-row sm:justify-between 2xl:items-center gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input placeholder="Search here"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>
              </div>

              <div>
                <button nz-button nzBlock class="outline-button w-full md:w-5" (click)="resetSearch()">
                  Reset All
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable [nzData]="supplierData" [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto', y: '550px' }"
            nzOuterBordered
          >
            <thead>
            <tr>
              <th>Supplier ID</th>
              <th>Supplier Name</th>
              <th>Mobile Number</th>
              <th>Email</th>
              <th>Number of Drivers</th>
              <th>
                <div class="flex">
                  <span>Created Date</span>
                  <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                        class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                  <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                        class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                </div>
              </th>
              <th *appHasAnyPrivilege="'SUPPLIER_SINGLE_VIEW,SUPPLIER_DELETE,SUPPLIER_UPDATE'">Actions</th>

            </tr>
            </thead>
            <tbody>

            <tr *ngFor="let data of basicTable.data" class="align-baseline">
              <td  style="min-width: 100px;">
                <a *appHasAnyPrivilege="'SUPPLIER_SINGLE_VIEW'" class="clickable-text"
                   (click)="navigateToSingle(this.data)">{{data.supplierId}}</a>
                <span *ngIf="!hasPermission('SUPPLIER_SINGLE_VIEW')">{{data.supplierId}}</span>
              </td>
              <td style="min-width: 150px;">{{data.supplierDetails.name}}</td>
              <td style="min-width: 150px;" class="clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{data.supplierDetails.mobileNo}}">{{data.supplierDetails.mobileNo}}</a></td>
              <td style="min-width: 150px;" class="clickable-mail-phone_no"  ><a class="clickable-mail-phone_no" href="mailto:{{data.supplierDetails.email}}">{{data.supplierDetails.email}}</a></td>
              <td style="min-width: 150px;">{{data?.drivers.length}}</td>
              <td style="min-width: 150px;">{{ data.createdAt | date:'yyyy-MM-dd' }}</td>
              <td style="min-width: 150px;" *appHasAnyPrivilege="'SUPPLIER_SINGLE_VIEW,SUPPLIER_DELETE,SUPPLIER_UPDATE'">
                <button *appHasAnyPrivilege="'SUPPLIER_UPDATE'" (click)="editNavigate(this.data)"
                        class="outline-button mr-3" nz-button nzType="default"
                >
                  Edit
                </button>
                <button *appHasAnyPrivilege="'SUPPLIER_SINGLE_VIEW,SUPPLIER_DELETE'"
                        class="outline-button more-dropdown"
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter"
                >
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *appHasAnyPrivilege="'SUPPLIER_SINGLE_VIEW'" nz-menu-item nz-popconfirm nz-button
                        (click)="navigateToSingle(this.data)">View
                    </li>
                    <a *appHasAnyPrivilege="'SUPPLIER_DELETE'"
                       nz-popconfirm
                       nzPopconfirmTitle="Are you sure delete this Supplier?"
                       nzPopconfirmPlacement="bottom"
                       (nzOnConfirm)="deleteSupplier(this.data._id)"
                    >
                      <li nz-menu-item nz-popconfirm nz-button nzDanger>Delete</li>
                    </a>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>

            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
      </div>
    </div>
  </nz-card>

</section>
